export const percentagemStatus = (data:GQL.IUserResponse) => {
    const percentageCel = data.telephone == null ? 0 : 34 ;
    const percentageEmail = data.email == null ? 0 : 33
    const percentageCep = data.cep  == null ? 0 : 33
    return percentageCel + percentageEmail + percentageCep;
    // const list = Object.values(data).filter(e=>{
    //     return e && e != ""
    // })
    // return Math.round((100 / Object.values(data).length) * list.length);
}